import labels from "../../utils/labels";
import constraintStyle from "../../styles/constraint.module.css";

const ConstraintTableHeader = () => (
  <div
    role="rowheader"
    className={constraintStyle.dataTableHeaderRow}
    style={{ paddingLeft: "var(--padding-2xl)" }}
  >
    <h4>{labels.consideration}</h4>
    <h4>{labels.startDate}</h4>
    <h4>{labels.endDate}</h4>
    <h4>{labels.comment}</h4>
    <h4 className={constraintStyle.author}>{labels.author}</h4>
    <h4 className={constraintStyle.actionColumn}>{labels.edit}</h4>
    <h4 className={constraintStyle.actionColumn}>{labels.delete}</h4>
  </div>
);

export default ConstraintTableHeader;
